import styled from "@emotion/styled";
import React from "react";

import DesktopMenu from "./deskTopMenu";
import MobileMenu from "./mobileMenu";
import { MenuContainer } from "./styles";

const MenuList = [
  ["Home", "/"],
  ["Tokenomics", "/tokenomics"],
  ["Join Telegram", "https://t.me/kirineth"],
];
const checkSticky = "";
const Menu = () => {
  return (
    <MenuContainer>
      <DesktopMenu menuList={MenuList} />
      <MobileMenu menuList={MenuList} />
    </MenuContainer>
  );
};

export default Menu;
